var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"teal darken-4",attrs:{"id":"user_app"}},[_c('notification'),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }